var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayPartiallyClearWithRain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "154px",
    viewBox: "0 0 136 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day-partially-clear-with-rain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.3617045%",
    y1: "72.8710337%",
    x2: "63.6421593%",
    y2: "39.9796521%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.5161778%",
    y1: "64.9090909%",
    x2: "8.62380839%",
    y2: "22.6545455%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "day-partially-clear-with-rain",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EFCC00",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 49.681863,
    r: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,0.181862989 L84,11.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,88.181863 L84,99.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,50.181863 L45,50.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,50.181863 L134,50.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,14.181863 L57,22.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,77.181863 L120,85.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,85.181863 L57,77.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,22.181863 L120,14.181863",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6759917,34.181863 C59.8900952,34.1492058 74.7864611,43.070145 82.3604414,57.3487861 C94.8397967,50.0818082 110.55339,51.382919 121.656555,60.6025676 C132.75972,69.8222161 136.871287,84.9831696 131.938648,98.5166553 C127.006009,112.050141 114.08701,121.053787 99.6311764,121.03272 L43.6759917,121.181863 C19.5544075,121.181863 0,101.70627 0,77.6819079 C0,53.6575461 19.5544075,34.181863 43.6759917,34.181863 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    transform: "translate(99.376091, 87.169323) rotate(-74.390000) translate(-99.376091, -87.169323) ",
    cx: 99.3760914,
    cy: 87.1693226,
    rx: 34.1705349,
    ry: 34.2478481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,133.181863 L66,150.181863",
    id: "Path",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,128.181863 L51,145.181863",
    id: "Path",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,128.181863 L81,145.181863",
    id: "Path",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayPartiallyClearWithRain);
export default __webpack_public_path__ + "static/media/day-partially-clear-with-rain.6afe993a1fe36dfe56be96fc6d217f00.svg";
export { ForwardRef as ReactComponent };